import { givenNameFromFullName } from "./clientAppUtils";

export function commentAuthorName(author) {
  return givenNameFromFullName(author?.full_name) || author?.full_name || "Клиент";
}

export function replyTargetLabel(parentAuthor) {
  if (!parentAuthor?.full_name) return null;
  return commentAuthorName(parentAuthor);
}

/** Имя в дательном падеже для «→ Елизавете» */
export function replyTargetNameDative(parentAuthor) {
  const name = replyTargetLabel(parentAuthor);
  if (!name) return null;
  if (name.endsWith("ия")) return `${name.slice(0, -1)}и`;
  if (name.endsWith("ья")) return `${name.slice(0, -2)}ье`;
  if (name.endsWith("а")) return `${name.slice(0, -1)}е`;
  if (name.endsWith("я")) return `${name.slice(0, -1)}е`;
  return name;
}

/** Корневой комментарий для любого ответа */
export function commentRootId(comment, byId) {
  let cur = comment;
  const seen = new Set();
  while (cur?.parent_id && !seen.has(cur.parent_id)) {
    seen.add(cur.parent_id);
    const parent = byId.get(cur.parent_id);
    if (!parent) break;
    cur = parent;
  }
  return cur.id;
}

/** Плоский список → ветки { comment, replies[] } */
export function buildCommentThreads(comments) {
  const list = [...(comments || [])];
  if (!list.length) return [];

  const byId = new Map(list.map((c) => [c.id, c]));
  const roots = list
    .filter((c) => !c.parent_id)
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  const repliesByRoot = new Map();
  for (const c of list) {
    if (!c.parent_id) continue;
    const rootId = commentRootId(c, byId);
    if (!repliesByRoot.has(rootId)) repliesByRoot.set(rootId, []);
    repliesByRoot.get(rootId).push(c);
  }

  for (const [, replies] of repliesByRoot) {
    replies.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
  }

  return roots.map((comment) => ({
    comment,
    replies: repliesByRoot.get(comment.id) || [],
  }));
}

export function repliesPreviewCount(total) {
  if (total <= 2) return total;
  return 1;
}

export function repliesWord(count) {
  const n = Math.abs(Number(count)) || 0;
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return "ответ";
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "ответа";
  return "ответов";
}
